import React, { Suspense } from 'react';
import { lazyWithRetry } from './lazyWithRetry';
import { ThemeProvider } from '@material-ui/core/styles'
import { Provider } from 'react-redux'
import { createMuiTheme } from '@material-ui/core/styles';
import { purple } from '@material-ui/core/colors';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import { createStore } from 'redux';
import reducer from "./store/reducer"
import ReactGA from 'react-ga';
const HomePage = lazyWithRetry(() => import(/* webpackPrefetch: true, webpackChunkName: "homepage" */'./Home/HomePage'));
const App = lazyWithRetry(() => import(/* webpackPrefetch: true, webpackChunkName: "app" */'./App'));
const store = createStore(reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
ReactGA.initialize('UA-169613319-1', { debug: false });

const theme = createMuiTheme({
    palette: {
        primary: purple,
        secondary: {
            main: "#ffffff"
        },
    },
    status: {
        danger: 'orange',
    },
    typography: {
        // In Chinese and Japanese the characters are usually larger,
        // so a smaller fontsize may be appropriate.
        fontSize: 7,
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*': {
                    'scrollbar-width': 'thin',
                },
                '*::-webkit-scrollbar': {
                    width: '6px',
                    height: '6px',
                },
                '*::-webkit-scrollbar-track': {
                    background: 'white'
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'grey',
                    borderRadius: '2px',
                },
            }
        }
    }
});

export default function AppOuter(props) {
    return (
        <div >
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <Router>
                        <Suspense fallback={<div>Loading...</div>}>
                            <Switch>
                                <Route exact path="/" component={HomePage} />
                                <Route component={App} />
                            </Switch>
                        </Suspense>
                    </Router>
                </ThemeProvider>
            </Provider>
        </div >

    );
}